<template>
  <el-dialog class="flex_c" style="margin-top:-15vh;" title="Welcome to Your Lesson!" :close-on-click-modal="false" :visible.sync="dialog" center>
    <div class="flex_v flex_c">
      <el-button type="primary" @click="toZoom">Join Meeting</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import zoomBtn from '@/components/zoomBtn';
export default {
  components: { zoomBtn },
  computed: {
    ...mapState(['session', 'user']),
  },
  data() {
    return {
      dialog: true,
    };
  },
  methods: {
    toZoom() {
      this.dialog = false
      const userName = this.user?.nickname || this.user?.name || '';
      const url = location.origin + '/livekit?name=' + encodeURIComponent(userName) + '&sid=' + this.session.sid;
      this.$store.commit('setMeeting', {
        active: true,
        minimized: false,
        url: url,
        name: userName
      });
    },
  }
};
</script>


